import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

export const getUserFacilities = async () => {
  const response = await axios.get('Transport/UserFacilities');
  return response;
};

export const getResidents = async (facilityId) => {
  const response = await axios.get(`Transport/Residents?facilityId=${facilityId}`);
  return response;
};

export const getResidentDetails = async (residentId) => {
  const response = await axios.get(`Transport/ResidentDetails?residentId=${residentId}`);
  return response;
};

export const getTransportTypes = async () => {
  const response = await axios.get(`Transport/TransportTypes`);
  return response;
};

export const getDoctorTypes = async () => {
  const response = await axios.get(`Transport/DoctorTypes`);
  return response;
};

export const getDoctorsByFacility = async (facilityId) => {
  const response = await axios.get(`Transport/DoctorsByFacility?facilityId=${facilityId}`);
  return response;
};

export const getAllDoctors = async () => {
  const response = await axios.get('Transport/AllDoctors');
  return response;
};

export const getOutsourceCompaniesByFacility = async (facilityId) => {
  const response = await axios.get(`Transport/OutsourceCompaniesByFacility?facilityId=${facilityId}`);
  return response;
};

export const getAllOutsourceCompanies = async () => {
  const response = await axios.get(`Transport/AllOutsourceCompanies`);
  return response;
};

export const getFacilityVehicles = async (facilityId) => {
  const response = await axios.get(`Transport/FacilityVehicles?facilityId=${facilityId}`);
  return response;
};

export const getAllVehicles = async () => {
  const response = await axios.get(`Transport/AllVehicles`);
  return response;
};

export const getDrivers = async (facilityId) => {
  const response = await axios.get(`Transport/Drivers?facilityId=${facilityId}`);
  return response;
};

export const getRestrictedDates = async (facilityId) => {
  const response = await axios.get(`Transport/RestrictedDates?facilityId=${facilityId}`);
  return response;
};

export const getTransportRequestList = async (startDate, endDate) => {
  const response = await axios.get(`Transport/TransportRequestList?startDate=${startDate}&endDate=${endDate}`);
  return response;
};

export const getTransportRequestById = async (transportId, occurrenceDate = null, occurrenceId = null) => {
  const response = await axios.get(
    `Transport/TransportRequestById?transportId=${transportId}&occurrenceDate=${occurrenceDate}&occurrenceId=${occurrenceId}`
  );
  return response;
};

export const saveTransportStatus = async (data) => {
  const formData = objectToFormData({ transportStatusInputData: data });
  const response = await axios.post('Transport/SaveTransportRequestStatus', formData);
  return response;
};

export const saveTransportRequest = async (data) => {
  const formData = objectToFormData({ transportInputData: data });
  const response = await axios.post('Transport/SaveTransportRequest', formData);
  return response;
};

export const updateTransportRequest = async (data, individualOccurrenceEdit = false) => {
  const formData = objectToFormData({ transportInputData: data });
  const response = await axios.post(
    `Transport/UpdateTransportRequest?individualOccurrenceEdit=${individualOccurrenceEdit}`,
    formData
  );
  return response;
};

export const saveOutsourceCompany = async (data) => {
  const formData = objectToFormData({ outsourceCompanyInputData: data });
  const response = await axios.post('Transport/SaveOutsourceCompany', formData);
  return response;
};

export const deleteOutsourceCompany = async (outsourceCompanyId) => {
  const response = await axios.post(`Transport/DeleteOutsourceCompany?outsourceCompanyId=${outsourceCompanyId}`);
  return response;
};

export const saveVehicle = async (data) => {
  const formData = objectToFormData({ vehicleInputData: data });
  const response = await axios.post('Transport/SaveVehicle', formData);
  return response;
};

export const deleteVehicle = async (vehicleId) => {
  const response = await axios.post(`Transport/DeleteVehicle?vehicleId=${vehicleId}`);
  return response;
};

export const saveDoctor = async (data) => {
  const formData = objectToFormData({ doctorInputData: data });
  const response = await axios.post('Transport/SaveDoctor', formData);
  return response;
};

export const deleteDoctor = async (doctorId) => {
  const response = await axios.post(`Transport/DeleteDoctor?doctorId=${doctorId}`);
  return response;
};

export const updateResidentDetails = async (data) => {
  const formData = objectToFormData({ inputData: data });
  const response = await axios.post('Transport/UpdateResidentDetails', formData);
  return response;
};
